type IconLibrary = 'fontAwesome4' | 'fontAwesome5' | 'materialSymbolsRounded';

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Window {
        __iconLibrary?: IconLibrary;
    }
}

export function SetIconLibrary(lib: IconLibrary) {
    window.__iconLibrary = lib;
}

export function GetIconLibrary(): IconLibrary {
    if (window.__iconLibrary === undefined) {
        throw new Error('Icon library not set');
    }
    return window.__iconLibrary;
}
